// extracted by mini-css-extract-plugin
export default {"BenefitsContainer":"Benefits_BenefitsContainer__-FWA0"};